import * as React from 'react';
const test = ({item}) => {
  return (
    <div>
      {/* ────────────── 상단 헤더 영역 ────────────── */}
      <table style={{
        width: '100%',
        borderCollapse: 'collapse',
        marginBottom: '8px'
      }}>
        <tbody>
          {/* 1행: 왼쪽 세로 병합 그레이 박스 + 타이틀 영역 */}
          <tr>
            <td
              rowSpan={5}
              style={{
                backgroundColor: '#f0f0f0',
                border: '1px solid #000',
                width: '60px'
              }}
            />
            <td
              colSpan={3}
              style={{
                border: '1px solid #000',
                height: '40px'
              }}
            >
              {item.title}
            </td>
          </tr>
          {/* 2행: 작성일 */}
          <tr>
            <td style={{ border: '1px solid #000', width: '15%' }}>
              {item.dateLabel}
            </td>
            <td
              colSpan={2}
              style={{ border: '1px solid #000' }}
            >
              {item.date}
            </td>
          </tr>
          {/* 3행: 견적번호 */}
          <tr>
            <td style={{ border: '1px solid #000' }}>
              {item.estimateNoLabel}
            </td>
            <td style={{ border: '1px solid #000', width: '25%' }}>
              {item.estimateNo}
            </td>
            <td style={{ border: '1px solid #000' }}>
              {item.blankCell /* 필요없으면 삭제 */}
            </td>
          </tr>
          {/* 4행: 의뢰자 */}
          <tr>
            <td style={{ border: '1px solid #000' }}>
              {item.requesterLabel}
            </td>
            <td colSpan={2} style={{ border: '1px solid #000' }}>
              {item.requester}
            </td>
          </tr>
          {/* 5행: 연락처 */}
          <tr>
            <td style={{ border: '1px solid #000' }}>
              {item.contactLabel}
            </td>
            <td style={{ border: '1px solid #000' }}>
              {item.tel}
            </td>
            <td style={{ border: '1px solid #000' }}>
              {item.fax}
            </td>
          </tr>
        </tbody>
      </table>

      {/* ────────────── 중단 고객 정보 영역 ────────────── */}
      <table style={{
        width: '100%',
        borderCollapse: 'collapse',
        marginBottom: '8px'
      }}>
        <tbody>
          <tr>
            <td style={{
              borderBottom: '1px dotted #999',
              padding: '6px',
              backgroundColor: '#fafafa',
              width: '15%'
            }}>
              {item.clientLabel}
            </td>
            <td style={{
              borderBottom: '1px dotted #999',
              padding: '6px'
            }}>
              {item.client}
            </td>
            <td style={{
              borderBottom: '1px dotted #999',
              padding: '6px',
              width: '15%'
            }}>
              {item.deptLabel}
            </td>
            <td style={{
              borderBottom: '1px dotted #999',
              padding: '6px'
            }}>
              {item.department}
            </td>
          </tr>
          <tr>
            <td style={{
              borderBottom: '1px dotted #999',
              padding: '6px',
              backgroundColor: '#fafafa'
            }}>
              {item.managerLabel}
            </td>
            <td style={{
              borderBottom: '1px dotted #999',
              padding: '6px'
            }}>
              {item.manager}
            </td>
            <td style={{
              borderBottom: '1px dotted #999',
              padding: '6px'
            }}>
              {item.managerContactLabel}
            </td>
            <td style={{
              borderBottom: '1px dotted #999',
              padding: '6px'
            }}>
              {item.managerContact}
            </td>
          </tr>
        </tbody>
      </table>

      {/* ────────────── 하단 품목 리스트 영역 ────────────── */}
      <table style={{
        width: '100%',
        borderCollapse: 'collapse'
      }}>
        <thead>
          <tr style={{
            borderTop: '2px solid #000',
            borderBottom: '2px solid #000'
          }}>
            {['No','품명/규격','단위','수량','단가','금액'].map((h, i) => (
              <th
                key={i}
                style={{
                  padding: '6px',
                  textAlign: 'center'
                }}
              >
                {h}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {item.items.map((row, idx) => (
            <tr
              key={idx}
              style={{ borderTop: '1px dotted #999' }}
            >
              <td style={{ padding: '6px', textAlign: 'center' }}>
                {idx + 1}
              </td>
              <td style={{ padding: '6px' }}>{row.name}</td>
              <td style={{ padding: '6px', textAlign: 'center' }}>
                {row.unit}
              </td>
              <td style={{ padding: '6px', textAlign: 'right' }}>
                {row.qty}
              </td>
              <td style={{ padding: '6px', textAlign: 'right' }}>
                {row.unitPrice}
              </td>
              <td style={{ padding: '6px', textAlign: 'right' }}>
                {row.amount}
              </td>
            </tr>
          ))}
        </tbody>
        <tfoot>
          <tr style={{
            borderTop: '2px solid #000',
            borderBottom: '2px solid #000'
          }}>
            <td colSpan={5} style={{
              padding: '6px',
              textAlign: 'right'
            }}>
              합계
            </td>
            <td style={{
              padding: '6px',
              textAlign: 'right'
            }}>
              {item.totalAmount}
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
  );
}
export default test;